import { FETCH_NEWS_FAILURE, FETCH_NEWS_REQUEST, FETCH_NEWS_SUCCESS } from "../../actions/opportunities/newsActions";

  const initialState = {
    newsLoading: true,
    newsData: [],
    newsError: null,
  };
  
  const newsReducer = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_NEWS_REQUEST:
        return { ...state, newsLoading: true , payload: action.payload};
      case FETCH_NEWS_SUCCESS:
        return { ...state, newsLoading: false, newsData: action.payload };
      case FETCH_NEWS_FAILURE:
        return { ...state, newsLoading: false, newsError: action.payload };       
      default:
        return state;
    }
  };
  
  export default newsReducer;